import { render, staticRenderFns } from "./SkeltonListTop.vue?vue&type=template&id=3c92e2a4&scoped=true&"
import script from "./SkeltonListTop.vue?vue&type=script&lang=js&"
export * from "./SkeltonListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92e2a4",
  null
  
)

export default component.exports